module.exports = __webpack_public_path__ + "static/media/Modern blue-01.1940e674.jpg";